import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link, useParams } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import Locked from "../../../../components/View/Locked";

const CreateLinkedinSender = () => {
  const { poolId } = useParams();
  const lang = useLanguage((s) => s.language);
  const route = poolId
    ? `/senders/pool/${poolId}/linkedin/create`
    : `/senders/linkedin/create`;

  return (
    <Locked
      boxProps={{w: "auto"}}
      left={-116}
    >
      {(isLocked) => (
        <Button
          leftSection={<IconPlus size={18} />}
          radius={"md"}
          color="primary"
          component={isLocked ? undefined : Link}
          to={route}
          size="md"
          disabled={isLocked}
        >
          {lang.senders.linkedin.add_account}
        </Button>
      )}
    </Locked>
  );
};

export default CreateLinkedinSender;
